import { RecentlyViewed } from '@theme/recently-viewed-products';

/**
 * Fills the "Recently viewed" section with the products stored by RecentlyViewed.
 * The cards are rendered server-side by re-requesting this same section through the
 * search route with an `id:` query, so they match every other product card.
 */
class RecentlyViewedSection extends HTMLElement {
  connectedCallback() {
    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries[0]?.isIntersecting) return;
        observer.disconnect();
        this.#load();
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    // A hidden element never intersects, so observe the section wrapper instead.
    observer.observe(this.parentElement ?? this);
  }

  async #load() {
    const { sectionId, productId, searchUrl, maxProducts } = this.dataset;
    if (!sectionId || !searchUrl) return;

    const ids = RecentlyViewed.getProducts()
      .filter((id) => id !== productId)
      .slice(0, Number(maxProducts) || 3);
    if (!ids.length) return;

    const query = ids.map((id) => `id:${id}`).join(' OR ');
    const url = `${searchUrl}?q=${encodeURIComponent(query)}&type=product&section_id=${sectionId}`;

    try {
      const response = await fetch(url);
      if (!response.ok) return;

      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const list = html.querySelector('[data-recently-viewed-list]');
      const target = this.querySelector('[data-recently-viewed-list]');
      if (!list || !target || !list.querySelector('.resource-list__item')) return;

      target.replaceWith(list);
      this.hidden = false;
    } catch (error) {
      console.error('Recently viewed products error:', error);
    }
  }
}

if (!customElements.get('recently-viewed-section')) {
  customElements.define('recently-viewed-section', RecentlyViewedSection);
}
